import axios from 'axios'
import { generateResponse, generateErrorResponse } from './common'

const API_END_POINT = process.env.API_END_POINT
const RESUME = API_END_POINT + '/users/resume'
const RESUMES = API_END_POINT + '/users/resumes'

export default {
  API_END_POINT: API_END_POINT,
  switchSelectedStatus (token, data, status) {
    if (status === 'delete') {
      return axios({
        url: RESUMES,
        method: 'delete',
        data: {
          userId: data.userId,
          resumes: data.resumes
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then(generateResponse, generateErrorResponse)
    } else {
      let changeStatus
      if (status === 'open') {
        changeStatus = 'published'
      } else {
        changeStatus = 'unpublished'
      }
      return axios({
        url: RESUMES,
        method: 'post',
        data: {
          userId: data.userId,
          status: changeStatus,
          resumes: data.resumes
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then(generateResponse, generateErrorResponse)
    }
  },
  switchStatus (token, data, status) {
    if (status === 'deleted') {
      return axios({
        url: RESUME + '/' + data.resumeId,
        method: 'delete',
        data: {
          userId: data.userId
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then(generateResponse, generateErrorResponse)
    } else {
      let changeStatus
      if (status) {
        changeStatus = 'published'
      } else {
        changeStatus = 'unpublished'
      }
      return axios({
        url: RESUME + '/' + data.resumeId,
        method: 'post',
        data: {
          userId: data.userId,
          status: changeStatus
        },
        headers: {
          Authorization: 'Bearer ' + token
        }
      }).then(generateResponse, generateErrorResponse)
    }
  },
  getForUsersById (token, id) {
    return axios({
      url: RESUME,
      method: 'get',
      params: {
        resumeId: id
      },
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  getForUsers (token, params) {
    return axios({
      url: RESUME,
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  clone (token, data) {
    return axios({
      url: RESUME,
      method: 'put',
      data: data,
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  update (token, id, data) {
    return axios({
      url: RESUME + '/' + data.resumeId,
      method: 'post',
      data: Object.assign({}, data, {
        userId: id
      }),
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  },
  add (token, id, data) {
    return axios({
      url: RESUME,
      method: 'post',
      data: Object.assign({}, data, {
        userId: id
      }),
      headers: {
        Authorization: 'Bearer ' + token
      }
    }).then(generateResponse, generateErrorResponse)
  }
}



// WEBPACK FOOTER //
// ./src/api/resumes.js